var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{staticClass:"gmap",attrs:{"options":_vm.options,"center":_vm.position,"zoom":_vm.zoom,"map-type-id":"roadmap"}},[_c('GmapMarker',{attrs:{"position":_vm.position}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }